import { ApolloQueryResult } from '@apollo/client';
import { GetShippingBlockDataQueryResult } from 'lib/graphql-generated';
import { ShippingOption } from './shipping-option';

interface Props {
  name: string;
  options: {
    name: string;
    description: string;
    id: string;
    price: number;
    from: number;
    to: number;
  }[];
}

export const ShippingSegment = ({ options, name }: Props) => {
  return (
    <>
      <article className='bg-white space-y-6 p-4 sm:p-6 shadow rounded-md flex flex-col'>
        <dt className='text-lg leading-6 font-medium text-gray-900'>{name}</dt>
        <dd>
          <ul className='border rounded divide-y divide-gray-200'>
            {options.map((opt) => (
              <ShippingOption
                name={opt.name}
                description={opt.description}
                id={opt.id}
                price={opt.price}
                from={opt.from}
                to={opt.to}
                key={opt.id}
              />
            ))}
          </ul>
        </dd>
      </article>
    </>
  );
};
